import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MaterialsModule } from 'src/app/shared/materials/materials.module';
import { DataCountCardComponent } from './data-count-card.component';

@NgModule({
  declarations: [DataCountCardComponent],
  imports: [CommonModule, MaterialsModule],
  exports: [DataCountCardComponent],
})
export class DataCountCardModule {}
